import React from 'react';
import { uniqueId } from 'lodash-es';
import { ModalForm } from '../forms/ModalForm';

export class Modal extends React.Component {
    static ask(options = {}) {
        return new Promise((resolve) => Modal.__singletonRef.__show({ ...options || {}, onSubmit: (values) => resolve(values ?? true), onClose: () => resolve(false) }));
    }

    static show(options = {}) {
        Modal.__singletonRef.__show(options);
    }

    static hide() {
        Modal.__singletonRef.__hide();
    }

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            body: null,
            ModalFormProps: {
                title: '',
                keyboard: true,
                backdrop: true,
                onSubmit: null,
                SaveButtonProps: {},
            },
        };

        Modal.__singletonRef = this;
        this.handleSubmit = this.handleSubmit.bind(this);
        this.__hide = this.__hide.bind(this);
        this.__show = this.__show.bind(this);
    }

    __show(options) {
        const { body, ...restOptions } = options;

        this.setState({
            show: true,
            modalId: `modal-${uniqueId()}`,
            body,
            ModalFormProps: restOptions || {},
        });
    }

    __hide() {
        const { ModalFormProps } = this.state;
        if (ModalFormProps?.onClose) {
            ModalFormProps.onClose();
        }
        this.setState({ show: false, body: null, ModalFormProps: {} });
    }

    async handleSubmit(values) {
        const { ModalFormProps } = this.state;
        const { onSubmit } = ModalFormProps || {};

        let submitResult = {};

        if (onSubmit) {
            submitResult = await onSubmit(values);
        }

        if (!submitResult?.keepOpen) {
            this.__hide();
        }
    }

    render() {
        const {
            show, body: BodyComponent, ModalFormProps, modalId,
        } = this.state;

        if (!show) {
            return null;
        }

        const {
            title, keyboard, backdrop, SaveButtonProps,
            ...restModalFormProps
        } = ModalFormProps;

        return (
            <ModalForm
                key={modalId}
                {...restModalFormProps}
                title={title}
                keyboard={keyboard}
                backdrop={backdrop}
                toggle={this.__hide}
                isOpen={show}
                onSubmit={this.handleSubmit}
                SaveButtonProps={{
                    ...SaveButtonProps || {},
                }}
            >
                {typeof BodyComponent === 'string'
                    ? BodyComponent
                    : ({
                        setFieldValue, values, onChange, errors,
                    }) => (
                        <BodyComponent
                            setFieldValue={setFieldValue}
                            values={values}
                            onChange={onChange}
                            errors={errors}
                        />
                    )}
            </ModalForm>
        );
    }
}

export * from './ConfirmDelete';
export * from './Alert';